import styled from 'styled-components/macro';
import { space, color, layout, typography, border, background, shadow } from 'styled-system';

const Button = styled.button<any>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border: 0;
  background-color: ${props => (props.primary ? 'var(--primary)' : 'white')};
  box-shadow: 0px 4px 10px ${props => props.theme.colors.text};
  padding: 18px 40px;
  cursor: pointer;
  font-size: 1em;
  border-radius: 16px;
  white-space: nowrap;
  z-index: 2;

  ${props => props.outlined && `
  background-color: transparent;
  border: 2px solid ${props.primary ? 'var(--primary)' : '#555'};
  color: ${props.primary ? 'var(--primary)' : 'white'};
`}

  & > div {
    display: flex;
    align-items: center;
  }

  &:focus {
    ${props => !props.outlined && 'none'};
    outline: 0 !important;
    outline-style: none;
  }

  &:active {
    box-shadow: 0 15px 20px rgba(0, 0, 0, 0.02);

    &:after {
      box-shadow: inset 0px -2px 5px ${props => (props.primary ? 'var(--primary)' : 'rgba(255, 255, 255)')},
        inset 0px 2px 5px ${props => (props.primary ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.15)')};
    }
  }

  ${props =>
    props.active &&
    `
    box-shadow: 0 15px 20px rgba(0, 0, 0, 0.02);
    
    &:after {
      box-shadow: inset 0px -2px 5px rgb(255, 255, 255), inset 0px 2px 5px rgba(0, 0, 0, 0.15);
    }
  `}

  ${props =>
    props.disabled &&
    `
    pointer-events: none;
    opacity:  ${props.active ? '0.8' : '0.5'};
  `}

  &:hover {
    opacity: 0.9;
    transform: scale(1.02);
    box-shadow: 0 2px 2px 2px black;
  }

  ${space};
  ${color};
  ${layout};
  ${typography};
  ${border};
  ${background};
  ${shadow};
`;

export default Button;
